import { useEffect, useState} from 'react'
import { useSelector,useDispatch} from 'react-redux'
import { TableContainer,Table,TableBody,TableRow,TableHead,TableCell } from '../styles/ScoresStyle.js';
import { BackButton,PageBreak} from '../styles/style.js';
import Tabs from './PageHelp/Tabs.jsx'
import Portal from '../API/Portal.js'
import Form from './forms/Form.jsx';
import { setForms } from '../redux/UserSlice.js';

const portal = new Portal();
export default function Scores({props}){
    const forms = useSelector((state)=>state.user.forms)
    const [selectedForms,setSelectedForms] = useState(undefined)
    const dispatch = useDispatch();

    useEffect(()=>{
        async function fetchForms(){
            var response  = await portal.readForms();
            if(response !== 'Read Forms Error'){
                dispatch(setForms(response))
            }
        }

        if(forms === undefined){
            fetchForms();
        }
    },[dispatch,forms])

    function getRows(){
        var rows = [];

        if(forms !== undefined){
            for(let i = 0;i < forms.length;i++){
                rows.push(
                    <TableRow onClick={()=>{setSelectedForms(forms[i])}}>
                        <TableCell>{forms[i].examDate}</TableCell>
                        <TableCell>{forms[i].examType}</TableCell>
                    </TableRow>
                )
            }
        }
        return rows;
    }

    function getTabs(){
        var optionList = [];
        var keys = Object.keys(selectedForms).sort();
        for(const key of keys){
            if(selectedForms[key] !== undefined && key !== 'examDate' && 
                key !== 'examType' && key !== 'patientID' && key !== 'triageScore'){
                optionList.push(
                    <div key={key} label={key}>
                        <PageBreak className='noMarginTop'></PageBreak>
                        <Form formName={key} formData={selectedForms[key]}/>
                    </div>
                )
            }
        }

        return optionList;
    }
    return(
        <>
            {selectedForms === undefined &&
                <>
                    <TableContainer>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableHead>Date</TableHead>
                                    <TableHead>Exam Type</TableHead>
                                </TableRow>
                                {getRows()}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Tabs>
                        <div label='Table'>
                            <PageBreak></PageBreak>
                        </div>

                        <div label='Graph'>
                            <PageBreak></PageBreak>
                        </div>
                    </Tabs>
                </>
            }

            {selectedForms !== undefined &&
                <>
                    <BackButton onClick={()=>{setSelectedForms(undefined)}}></BackButton>
                    <Tabs>
                        {getTabs()}
                    </Tabs>
                </>
            }
        </>
    )
}